Vue.component('tournament-svg', {
  props: {
    block: {
      type: Object,
      required: true,
    },
  },
  template: `<svg class="tournament-svg" :height="height" :width="width" :view-box.camel="viewBox" xmlns="http://www.w3.org/2000/svg">
  <g :transform="lineOffset" fill="none" font-family="sans-serif" font-size="12">
    <template v-for="(game, i) in games">
      <template v-for="(points, j) in game.params.points">
        <polyline :key="i + '-' + j" :points="points" :stroke="isWin(game, j) ? '#f30' : '#555'" :stroke-width="isWin(game, j) ? 3 : 1"></polyline>
      </template>
      <line :x1="game.params.x" :y1="game.params.y" :x2="parentX(game)" :y2="game.params.y" :stroke="game.gameOver ? '#f30' : '#555'" :stroke-width="game.gameOver ? 3 : 1"></line>
      <circle :cx="game.params.x" :cy="game.params.y" :r="13" stroke="#555" stroke-width="1" fill="#fff" style="cursor:pointer;" @click="$emit('click-game-node', game)"></circle>
      <text :x="game.params.x" :y="game.params.y + 1" text-anchor="middle" dominant-baseline="central" stroke="none" fill="black" style="pointer-events:none;">{{ game.name }}</text>
    </template>
  </g>
  <g transform="translate(0.5 0.5)" fill="#fff" stroke="#555" stroke-width="1">
    <rect v-for="(team, i) in teams" :key="i" x="0" :y="settings.rowHeight * i" :width="settings.labelWidth" :height="settings.rowHeight - 15"></rect>
  </g>
  <g font-family="sans-serif" font-size="14" stroke="none" fill="black">
    <text v-for="(team, i) in teams" :key="i" x="8" :y="settings.rowHeight * i + 23" :style="team.style">{{ team.name }}</text>
  </g>
</svg>`,
  data() {
    return {
      settings: {
        rowHeight: 50,
        colWidth: 40,
        labelWidth: 140,
        maxWidth: 300,
      },
    }
  },
  computed: {
    games() {
      return this.block.games || []
    },
    teams() {
      return this.block.teams.map((team) => {
        const name = team.display || team.shortName
        const rate = (this.settings.labelWidth - 15) / (name.length * 14)
        return {
          ...team,
          name,
          style: rate < 1 ? { transform: `scale(${rate}, 1)` } : {},
        }
      })
    },
    viewBoxHeight() {
      return this.block.teams.length * this.settings.rowHeight
    },
    viewBoxWidth() {
      const ys = this.games.map((item) => {
        return (
          parseInt(_.get(item, 'params.x', 0), 10) +
          this.settings.colWidth +
          this.settings.labelWidth
        )
      })
      ys.push(this.settings.maxWidth)
      return Math.max(...ys)
    },
    viewBox() {
      return `0, 0, ${this.viewBoxWidth}, ${this.viewBoxHeight}`
    },
    width() {
      return Math.min(this.settings.maxWidth, this.viewBoxWidth)
    },
    height() {
      return (this.viewBoxHeight * this.width) / this.viewBoxWidth
    },
    lineOffset() {
      return `translate(${this.settings.labelWidth + 0.5} -2.5)`
    },
  },
  methods: {
    parentX(game) {
      const parent = _.find(this.games, (item) => {
        const keys = item.params.children || []
        return keys.includes(game.params.key)
      })
      return parent ? parent.params.x : game.params.x + this.settings.colWidth
    },
    isWin(game, idx) {
      return !!Number(_.get(game, `gameRecords.${idx}.point`, 0))
    },
  },
})
